var React = require('react');

function ArrowDrop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.26338 0L3.99143 3.46014L0.719486 0L0 0.76087L3.27195 4.22101L3.99143 5L4.72805 4.22101L8 0.76087L7.26338 0Z","fill":"white"}));
}

ArrowDrop.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = ArrowDrop;

ArrowDrop.default = ArrowDrop;
